import { flagFactory } from '../icon';
import Svg from './at.svg';

export default flagFactory(Svg);
